import api from "./api";

export const subscriberService = {
  subscribe: async (email: string) => {
    return (await api.post("/subscribers", { email })).data;
  },
  unsubscribe: async (email: string) => {
    return (await api.delete(`/subscribers/${email}`)).data;
  },
  getAll: async () => {
    return (await api.get("/subscribers")).data;
  },
};

export default subscriberService